export default __webpack_public_path__ + "static/media/invoice.479ae9f2.png";